import * as $ from "jquery";

export default class GeckoSlideshow {
	container: HTMLElement;
	slideshow: any;
	height: number;

	constructor(el:HTMLElement) {
		this.container = el;
		setTimeout(() => {
			this.resizeContainer();
			this.initSlideshow();
		}, 500);
	}

	resizeContainer() {
		let containerHeight = 0;
		const requestedHeight = this.container.getAttribute('data-height');

		if (requestedHeight === "fill") {
			containerHeight = this.calculateFillHeight();
		} else {
			containerHeight = parseInt(requestedHeight);
		}

		this.container.style.height = containerHeight + "px";
	}

	calculateFillHeight() {
		let subHeight = 0;

		const heightDesktop = $('body > header.desktop:visible').outerHeight();
		const heightTouch = $('body > header.touch:visible').outerHeight();
		const heightFinder = $('#footer-location-finder').outerHeight();

		if (heightDesktop) { subHeight += heightDesktop; }
		if (heightTouch) { subHeight += heightTouch; }
		if (heightFinder) { subHeight += heightFinder; }

		return $(window).innerHeight() - subHeight;
	}

	initSlideshow() {
		let sliderOpts = {
			slidesPerView: 1,
			autoplay: 8000,
			speed: 1000,
			loop: true,
			draggable: false,
			grabCursor: false,

			// effect: 'fade',
			fade: {
				crossFade: true
			},

			keyboardControl: true,
			pagination: '.gecko-slideshow__pagination',
			paginationClickable: true,

			prevButton: '.swiper-button-prev',
			nextButton: '.swiper-button-next',

			onInit: (swiper) => {
				this.slideshow = swiper;
			},
		}
		const slideshow = new Swiper(this.container, sliderOpts);
	}
}